import { router } from '../router/router';
import { RouterProvider } from '@tanstack/react-router';

export default function PridWwwMain(): JSX.Element {
  return <RouterProvider router={router} />;
}
